import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { BRAND } from "../lib/brand";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0F1A14] text-gray-200 mt-24"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid gap-12 md:grid-cols-2 lg:grid-cols-4">
        <div className="space-y-4">
          <div className="flex items-center gap-3">
            <div className="bg-white rounded-md p-1">
              <img
                src={BRAND.logoUrl}
                alt="E L Lawn Services Inc"
                className="h-12 w-12 object-contain"
              />
            </div>
            <div className="font-display font-bold text-lg leading-tight">
              E L Lawn Services Inc
            </div>
          </div>
          <p className="text-sm text-gray-400 leading-relaxed font-body">
            Family-owned lawn care and landscaping serving South Florida with
            quality, reliability, and {BRAND.experienceYears}+ years of hands-on
            experience.
          </p>
        </div>

        <div>
          <h4 className="font-display font-semibold text-white mb-4">Quick Links</h4>
          <ul className="space-y-2 text-sm font-body">
            <li>
              <Link to="/" data-testid="footer-link-home" className="text-gray-300 hover:text-white">
                Home
              </Link>
            </li>
            <li>
              <Link to="/about" data-testid="footer-link-about" className="text-gray-300 hover:text-white">
                About Us
              </Link>
            </li>
            <li>
              <Link to="/services" data-testid="footer-link-services" className="text-gray-300 hover:text-white">
                Services
              </Link>
            </li>
            <li>
              <Link to="/contact" data-testid="footer-link-contact" className="text-gray-300 hover:text-white">
                Contact
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-display font-semibold text-white mb-4">Service Areas</h4>
          <ul className="space-y-2 text-sm font-body text-gray-300">
            {BRAND.serviceAreas.map((area) => (
              <li key={area} className="flex items-center gap-2">
                <span className="h-1.5 w-1.5 rounded-full bg-[#DC2626]" />
                {area}
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-display font-semibold text-white mb-4">Contact</h4>
          <ul className="space-y-3 text-sm font-body">
            <li>
              <a
                href={`tel:${BRAND.phoneTel}`}
                data-testid="footer-phone"
                className="flex items-center gap-3 text-gray-300 hover:text-white"
              >
                <Phone className="h-4 w-4 text-[#15803D]" />
                {BRAND.phone}
              </a>
            </li>
            <li>
              <a
                href={`mailto:${BRAND.email}`}
                data-testid="footer-email"
                className="flex items-center gap-3 text-gray-300 hover:text-white break-all"
              >
                <Mail className="h-4 w-4 text-[#15803D]" />
                {BRAND.email}
              </a>
            </li>
            <li className="flex items-start gap-3 text-gray-300">
              <MapPin className="h-4 w-4 mt-0.5 text-[#15803D] shrink-0" />
              <span data-testid="footer-address">{BRAND.address}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 text-center text-xs text-gray-400">
          <p>© {new Date().getFullYear()} E L Lawn Services Inc. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
